import React, { Component } from "react";

import "../../styles/css/ElevationForm/elevationForm.css";

class SectionB extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  render() {
    const { sectionB, onClickB, validateB } = this.props;
    // console.log(sectionB);
    return (
      <div>
        <div className="form-wrapper-elevation">
          <h2> FLOOD INSURANCE RATE MAP(FIRM) INFORMATION </h2>{" "}
          {sectionB.isSubmittedB === false ? (
            <div className="err-msg-content">
              Something went wrong.Please try again.{" "}
            </div>
          ) : null}{" "}
          <table>
            <tbody>
              <tr>
                <td colSpan="6">
                  <span>
                    Please make sure to select the correct
                    town/township/municipality in question B1 as there can be
                    more than one town with the same name.
                  </span>
                </td>
              </tr>
              <tr>
                <td colSpan="2">
                  <div className="question-wrapper">
                    <span> B1. </span>{" "}
                    <p className="qst-type">
                      {" "}
                      NFIP Community Name & Community Number{" "}
                    </p>{" "}
                  </div>{" "}
                </td>{" "}
                <td colSpan="2">
                  <div className="question-wrapper">
                    <span> B2. </span>{" "}
                    <p className="qst-type"> County Name {""} </p>{" "}
                  </div>{" "}
                </td>{" "}
                <td colSpan="2">
                  <div className="question-wrapper">
                    <span> B3. </span> <p className="qst-type"> State </p>{" "}
                  </div>{" "}
                </td>{" "}
              </tr>{" "}
              <tr>
                <td colSpan="2">
                  <div className="input-box-wrapper">
                    {" "}
                    {sectionB.community_options.length > 1 ? (
                      <select
                        id="community_name"
                        name="community_name"
                        value={sectionB.community_name}
                        className="form-input-box"
                        onChange={onClickB}
                      >
                        <option value={"null"}> Select </option>{" "}
                        {sectionB.community_options.map((option) => {
                          return (
                            <option
                              value={
                                option.community_name +
                                "-" +
                                option.community_number
                              }
                              key={option.community_number}
                            >
                              {option.community_name} -{" "}
                              {option.community_number}{" "}
                            </option>
                          );
                        })}{" "}
                      </select>
                    ) : sectionB.community_options.length === 1 ? (
                      <input
                        type="text"
                        name="community_name"
                        value={sectionB.community_options[0].community_name}
                        className="form-input-box"
                        onChange={onClickB}
                      />
                    ) : (
                      <input
                        type="text"
                        name="community_name"
                        value={sectionB.community_name}
                        className="form-input-box"
                        onChange={onClickB}
                      />
                    )}{" "}
                    {validateB.message(
                      "community name",
                      sectionB.community_name,
                      "alpha_num_dash_space",
                      { className: "error-msg-text" }
                    )}{" "}
                  </div>{" "}
                </td>{" "}
                <td colSpan="2">
                  <div className="input-box-wrapper">
                    <input
                      type="text"
                      name="county_name"
                      value={sectionB.county_name}
                      className="form-input-box"
                      onChange={onClickB}
                    />{" "}
                    {validateB.message(
                      "county name",
                      sectionB.county_name,
                      "alpha_num_dash_space",
                      { className: "error-msg-text" }
                    )}{" "}
                  </div>{" "}
                </td>{" "}
                <td colSpan="2">
                  <div className="input-box-wrapper">
                    <input
                      name="region"
                      type="text"
                      className="form-input-box"
                      value={sectionB.region}
                      onChange={onClickB}
                    />{" "}
                    {validateB.message(
                      "state",
                      sectionB.region,
                      "alpha_num_dash_space",
                      {
                        className: "error-msg-text",
                      }
                    )}{" "}
                  </div>{" "}
                </td>{" "}
              </tr>{" "}
              <tr>
                <td colSpan="2">
                  <div>
                    <div className="question-wrapper">
                      <span> B4. </span>{" "}
                      <p className="qst-type"> Map / Panel Number </p>{" "}
                    </div>{" "}
                    <div className="input-box-wrapper">
                      <input
                        type="text"
                        name="map_panel_no"
                        value={sectionB.map_panel_no}
                        className="form-input-box"
                        onChange={onClickB}
                      />{" "}
                      {validateB.message(
                        "map/panel no",
                        sectionB.map_panel_no,
                        "alpha_num_dash_space",
                        { className: "error-msg-text" }
                      )}{" "}
                    </div>{" "}
                  </div>{" "}
                </td>{" "}
                <td colSpan="2">
                  <div>
                    <div className="question-wrapper">
                      <span> B5. </span> <p className="qst-type"> Suffix </p>{" "}
                    </div>{" "}
                    <div className="input-box-wrapper">
                      <input
                        value={sectionB.suffix}
                        type="text"
                        name="suffix"
                        onChange={onClickB}
                        className="form-input-box"
                      />{" "}
                      {validateB.message(
                        "suffix",
                        sectionB.suffix,
                        "alpha_num_dash_space",
                        {
                          className: "error-msg-text",
                        }
                      )}{" "}
                    </div>{" "}
                  </div>{" "}
                </td>{" "}
                <td colSpan="2">
                  <div>
                    <div className="question-wrapper">
                      <span> B6. </span>{" "}
                      <p className="qst-type"> FIRM Index Date </p>{" "}
                    </div>{" "}
                    <div className="input-box-wrapper">
                      {" "}
                      {sectionB.firm_index_date !== "" ? (
                        <input
                          type="text"
                          name="firm_index_date"
                          className="form-input-box"
                          value={sectionB.firm_index_date}
                          onChange={onClickB}
                        />
                      ) : (
                        <input
                          placeholder="dd/mm/yyyy"
                          type="date"
                          name="firm_index_date"
                          className="form-input-box"
                          value={sectionB.firm_index_date}
                          onChange={onClickB}
                        />
                      )}{" "}
                      {/* {validateB.message(
                                                        "firm index date",
                                                        sectionB.firm_index_date,
                                                        "date",
                                                        { className: "error-msg-text" }
                                                      )} */}{" "}
                    </div>{" "}
                  </div>{" "}
                </td>{" "}
              </tr>{" "}
              <tr>
                <td colSpan="2">
                  <div>
                    <div className="question-wrapper">
                      <span> B7. </span>{" "}
                      <p className="qst-type">
                        FIRM Panel Effective / Revised Date{" "}
                      </p>{" "}
                    </div>{" "}
                  </div>{" "}
                </td>{" "}
                <td colSpan="2">
                  <div>
                    <div className="question-wrapper">
                      <span> B8. </span>{" "}
                      <p className="qst-type"> Flood Zone(s) </p>{" "}
                    </div>{" "}
                  </div>{" "}
                </td>{" "}
                <td colSpan="2">
                  <div>
                    <div className="question-wrapper">
                      <span> B9. </span>{" "}
                      <p className="qst-type">
                        Base Flood Elevation(s)(Zone AO, use Base Flood Depth){" "}
                      </p>{" "}
                    </div>{" "}
                  </div>{" "}
                </td>{" "}
              </tr>{" "}
              <tr>
                <td colSpan="2">
                  <div className="input-box-wrapper">
                    {" "}
                    {sectionB.effective_date !== "" ? (
                      <input
                        type="text"
                        name="effective_date"
                        value={sectionB.effective_date}
                        className="form-input-box"
                        onChange={onClickB}
                      />
                    ) : (
                      <input
                        type="date"
                        name="effective_date"
                        value={sectionB.effective_date}
                        className="form-input-box"
                        onChange={onClickB}
                      />
                    )}{" "}
                    {/* {validateB.message(
                                                      "effective date",
                                                      sectionB.effective_date,
                                                      "date",
                                                      { className: "error-msg-text" }
                                                    )} */}{" "}
                  </div>{" "}
                </td>{" "}
                <td colSpan="2">
                  <div className="input-box-wrapper">
                    <input
                      type="text"
                      name="floodZone"
                      className="form-input-box"
                      value={sectionB.floodZone}
                      onChange={onClickB}
                    />{" "}
                    {validateB.message(
                      "flood zone",
                      sectionB.floodZone,
                      "alpha_num_space",
                      { className: "error-msg-text" }
                    )}{" "}
                  </div>{" "}
                </td>{" "}
                <td colSpan="2">
                  <div className="input-box-wrapper">
                    <input
                      type="text"
                      name="static_BFE"
                      className="form-input-box"
                      value={sectionB.static_BFE}
                      onChange={onClickB}
                    />{" "}
                    {validateB.message(
                      "flood elevation depth",
                      sectionB.static_BFE,
                      "alpha_num_dash_space",
                      { className: "error-msg-text" }
                    )}{" "}
                  </div>{" "}
                </td>{" "}
              </tr>{" "}
              <tr>
                <td colSpan="6">
                  <div className="question-wrapper">
                    <span> B10. </span>{" "}
                    <p className="qst-type">
                      Indicate the source of the Base Flood Elevation(BFE) data
                      or base flood depth entered in Item B9:
                    </p>{" "}
                  </div>{" "}
                  <div className="input-horizontal">
                    <input
                      // disabled={sectionB.static_BFE !== ""}
                      type="radio"
                      name="fz_source"
                      checked={sectionB.fz_source === "FIS"}
                      value="FIS"
                      className="radio-btn"
                      onChange={onClickB}
                    />{" "}
                    <label className="checkbox-label"> FIS Profile </label>{" "}
                    <input
                      // disabled={sectionB.static_BFE !== ""}
                      type="radio"
                      name="fz_source"
                      checked={sectionB.fz_source === "FIRM"}
                      value="FIRM"
                      className="radio-btn"
                      onChange={onClickB}
                    />{" "}
                    <label className="checkbox-label"> FIRM </label>{" "}
                    <input
                      // disabled={sectionB.static_BFE !== ""}
                      type="radio"
                      checked={sectionB.fz_source === "Community"}
                      name="fz_source"
                      value="Community"
                      className="radio-btn"
                      onChange={onClickB}
                    />{" "}
                    <label className="checkbox-label">
                      Community Determined{" "}
                    </label>{" "}
                    <input
                      type="radio"
                      // checked={sectionB.static_BFE !== ""}
                      checked={
                        sectionB.fz_source === "other" ||
                        sectionB.static_BFE !== ""
                      }
                      name="fz_source"
                      value="other"
                      className="radio-btn"
                      onChange={onClickB}
                    />{" "}
                    <label className="checkbox-label"> Other / Source: </label>{" "}
                    <input
                      disabled={
                        sectionB.fz_source === "FIS" ||
                        sectionB.fz_source === "FIRM" ||
                        sectionB.fz_source === "Community"
                      }
                      type="text"
                      name="static_BFE"
                      className="input-half-cell"
                      value={sectionB.static_BFE}
                      onChange={onClickB}
                    />{" "}
                  </div>{" "}
                  {validateB.message(
                    "Base Flood Elevation",
                    sectionB.fz_source,
                    "alpha_num_dash_space",
                    { className: "error-msg-radio" }
                  )}{" "}
                </td>{" "}
              </tr>{" "}
              <tr>
                <td colSpan="6">
                  <div className="question-wrapper">
                    <span> B11. </span>{" "}
                    <p className="qst-type">
                      Indicate elevation datum used for BFE in Item B9:
                    </p>{" "}
                  </div>{" "}
                  <div className="input-horizontal">
                    <input
                      type="radio"
                      // disabled={sectionB.v_datum !== ""}
                      checked={sectionB.elevation_datum === "NGVD 1929"}
                      name="elevation_datum"
                      value="NGVD 1929"
                      className="radio-btn"
                      onChange={onClickB}
                    />{" "}
                    <label className="checkbox-label"> NGVD 1929 </label>{" "}
                    <input
                      type="radio"
                      // disabled={sectionB.v_datum !== ""}
                      checked={sectionB.elevation_datum === "NAVD 1988"}
                      name="elevation_datum"
                      value="NAVD 1988"
                      className="radio-btn"
                      onChange={onClickB}
                    />{" "}
                    <label className="checkbox-label"> NAVD 1988 </label>{" "}
                    <input
                      type="radio"
                      checked={
                        sectionB.v_datum !== "" ||
                        sectionB.elevation_datum === "other"
                      }
                      name="elevation_datum"
                      value="other"
                      className="radio-btn"
                      onChange={onClickB}
                    />{" "}
                    <label className="checkbox-label"> Other / Source: </label>{" "}
                    <input
                      type="text"
                      disabled={
                        sectionB.elevation_datum === "NGVD 1929" ||
                        sectionB.elevation_datum === "NAVD 1988"
                      }
                      value={sectionB.v_datum}
                      onChange={onClickB}
                      className="input-half-cell"
                      name="v_datum"
                    />
                  </div>{" "}
                  {validateB.message(
                    "elevation datum",
                    sectionB.elevation_datum,
                    "alpha_num_dash_space",
                    { className: "error-msg-radio" }
                  )}{" "}
                </td>{" "}
              </tr>{" "}
              <tr>
                <td colSpan="6">
                  <div className="question-wrapper">
                    <span> B12. </span>{" "}
                    <p className="qst-type">
                      Is the building located in a Coastal Barrier Resources
                      System(CBRS) area or Otherwise Protected Area(OPA) ?
                    </p>{" "}
                  </div>{" "}
                  <div className="info-link">
                    <p>
                      you can confirm this by checking{" "}
                      <a
                        target="_blank"
                        href="https://www.fws.gov/cbra/maps/mapper.html"
                      >
                        {" "}
                        Federal CBRS Mapper{" "}
                      </a>{" "}
                    </p>{" "}
                  </div>{" "}
                  <div className="input-horizontal">
                    <input
                      type="radio"
                      name="isLocation"
                      value="Yes"
                      checked={sectionB.isLocation === "Yes"}
                      onChange={onClickB}
                      className="radio-btn"
                    />
                    <label className="checkbox-label"> Yes </label>{" "}
                    <input
                      type="radio"
                      name="isLocation"
                      value="No"
                      checked={sectionB.isLocation === "No"}
                      onChange={onClickB}
                      className="radio-btn"
                    />
                    <label className="checkbox-label"> No </label>{" "}
                  </div>{" "}
                  {validateB.message(
                    "building location",
                    sectionB.isLocation,
                    "alpha_num_dash_space",
                    { className: "error-msg-radio" }
                  )}{" "}
                </td>{" "}
              </tr>{" "}
              <tr>
                <td colSpan="6">
                  <div className="designtion-row-wrapper">
                    <div className="sub-text-label">
                      <span className=""> Designation Date : </span>{" "}
                    </div>{" "}
                    <div className="sub-text-label">
                      <input
                        type="date"
                        name="designation_date"
                        value={sectionB.designation_date}
                        onChange={onClickB}
                        className="input-wrapper"
                      />{" "}
                      {validateB.message(
                        "designation date",
                        sectionB.designation_date,
                        "alpha_num_dash_space",
                        { className: "error-msg-text" }
                      )}{" "}
                    </div>{" "}
                    <div className="sub-text-label">
                      <input
                        type="radio"
                        name="building_location_area"
                        checked={sectionB.building_location_area === "CBRS"}
                        value="CBRS"
                        onChange={onClickB}
                        className="radio-btn"
                      />
                      <label className="checkbox-label"> CBRS </label>{" "}
                      <input
                        type="radio"
                        name="building_location_area"
                        checked={sectionB.building_location_area === "OPA"}
                        value="OPA"
                        onChange={onClickB}
                        className="radio-btn"
                      />
                      <label className="checkbox-label"> OPA </label>{" "}
                      {validateB.message(
                        "unit",
                        sectionB.building_location_area,
                        "alpha_num_dash_space",
                        { className: "error-msg-text" }
                      )}{" "}
                    </div>{" "}
                  </div>{" "}
                </td>{" "}
              </tr>{" "}
            </tbody>{" "}
          </table>{" "}
        </div>{" "}
      </div>
    );
  }
}

export default SectionB;



// WEBPACK FOOTER //
// ./src/pages/ElevationForm/SectionB.js